module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Epigraph")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-La"
  }, [_vm._v("… foliis tantum ne carmina manda,")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-La"
  }, [_vm._v("ne turbata volent rapidis ludibria ventis;")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-La"
  }, [_vm._v("ipsa canas oro.")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-space"
  }, [_vm._v("‘… do not set your songs down on the leaves,")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-En"
  }, [_vm._v("For they will fly away on the rushing winds,")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-En"
  }, [_vm._v("Which will scatter them like toys abandoned;")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-En"
  }, [_vm._v("Sing yourself, I pray.’")]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph-source"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Aeneid")]), _vm._v(" 6.74–6")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb84a34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781645367314_EPUB-5.vue
// module id = 72
// module chunks = 0